<template>
    <div class="userinfo">
        <div id="header_nav" class="header">
            <div class="logo border_box">
                <div class="logo_img"><img src=""></div>
                <div class="logo_txt wid300">天津市教育系统网络安全和舆情管控应急指挥平台</div>
            </div>
            <div class="userinfo_box">
                <div class="user_box" style="border: none;">
                    <div class="el-dropdown" style="width: 150px;">
                        <div class="user_img">
                            <img src="/ssologin/static/images/user_icon.png">
                            <span class="user_name">{{name}}</span>
                        </div>
                        <ul class="subset_nav">
                            <div style="position:absolute;height: 30px;width: 100%;top:-30px;left:0;"></div>
                            <li @click="gosetting('/Set/userinfo')">个人信息</li>
                            <li @click="gosetting('/Set/groupManagement')" v-if="funList.length > 0">系统设置</li>
                            <li @click="gosetting('/Set/systemLog')">日志审计</li>
                            <li @click="gosetting('/exit')">退出</li>
                            <div class="popper__arrow"></div>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div id="goBack" class="goback" @click='$router.push("/loginIndex")'>返回</div>

        <div class="userContent">
            <div class="content">
                <div class="tit"><span>个人信息</span></div>
                <div class="changBtn">
                    <el-button plain @click="changePwd = true;">修改密码</el-button>
                    <el-button plain @click="editMessage()">编辑信息</el-button>
                </div>
                <ul>
                    <li><span>登录帐号</span>{{login}}</li>
                    <li><span>姓名</span>{{name}}</li>
                    <li><span>手机号</span>{{phone}}</li>
                    <li><span>邮箱</span>{{email}}</li>
                    <li><span>微信号</span>{{wechat}}</li>
                </ul>
            </div>
        </div>
        <div class="footer"></div>
        <!-- 修改密码弹窗 -->
        <el-dialog :close-on-click-modal="false" title="修改密码" :visible.sync="changePwd" status-icon width="580px">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item label="登录帐号" :label-width="formLabelWidth">
                    {{login}}
                </el-form-item>
                <el-form-item label="旧密码" :label-width="formLabelWidth" prop="oldPwd">
                    <el-input v-model="form.oldPwd" :type="form.eyeShow ? 'text' : 'password'"></el-input>
                    <img class="eye" v-if="form.eyeShow" @click="form.eyeShow = !form.eyeShow" src="@/images/eye.png"
                        alt="">
                    <img class="eye" v-if="!form.eyeShow" @click="form.eyeShow = !form.eyeShow" src="@/images/eye_h.png"
                        alt="">
                </el-form-item>
                <el-form-item label="新密码" :label-width="formLabelWidth" prop="newPwd">
                    <el-input v-model="form.newPwd" autocomplete="off" :type="form.eyeShow1 ? 'text' : 'password'">
                    </el-input>
                    <img class="eye" v-if="form.eyeShow1" @click="form.eyeShow1 = !form.eyeShow1" src="@/images/eye.png"
                        alt="">
                    <img class="eye" v-if="!form.eyeShow1" @click="form.eyeShow1 = !form.eyeShow1"
                        src="@/images/eye_h.png" alt="">
                </el-form-item>
                <el-form-item label="确认密码" :label-width="formLabelWidth" prop="newPwdAgain">
                    <el-input v-model="form.newPwdAgain" autocomplete="off" :type="form.eyeShow2 ? 'text' : 'password'">
                    </el-input>
                    <img class="eye" v-if="form.eyeShow2" @click="form.eyeShow2 = !form.eyeShow2" src="@/images/eye.png"
                        alt="">
                    <img class="eye" v-if="!form.eyeShow2" @click="form.eyeShow2 = !form.eyeShow2"
                        src="@/images/eye_h.png" alt="">
                </el-form-item>
                <el-form-item label="" :label-width="formLabelWidth">
                  <p style="font-size:12px;line-height:20px;">提示：密码长度8位以上，密码复杂度为数字、字母及特殊字符两种以上组合，密码使用周期为180天。</p>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align:center;">
                <el-button @click="changePwd = false">取 消</el-button>
                <el-button type="primary" @click="changePwdSure('form')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 编辑信息弹窗 -->
        <el-dialog :close-on-click-modal="false" title="编辑信息" :visible.sync="editMsg" status-icon width="580px">
            <el-form :model="msgForm" :rules="msgRules" ref='msgForm'>
                <el-form-item label="登录帐号" :label-width="formLabelWidth">
                    {{login}}
                </el-form-item>
                <el-form-item label="姓名" :label-width="formLabelWidth" prop='name'>
                    <el-input v-model="msgForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" :label-width="formLabelWidth" prop='phone'>
                    <el-input v-model="msgForm.phone" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" :label-width="formLabelWidth" prop='email'>
                    <el-input v-model="msgForm.email" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="微信号" :label-width="formLabelWidth">
                    <el-input v-model="msgForm.wechat" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align:center;">
                <el-button @click="editMsg = false">取 消</el-button>
                <el-button type="primary" @click="changeMsgSure('msgForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as userInfo from "@/api/userInfo";
import * as loginAPI from "@/api/login.js";
import Util from '../../util/util.js'

let _util = new Util()
import qs from "qs";
export default {
    data() {
        let isMobile = /^1[3|5|8|7|9|6][0-9]{9}$/,
            isPwd = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
            isUserName = /^[\u4e00-\u9fa50-9]{1,10}$/,
            isEmail = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
        let oldPwd = (rule, value, callback) => {
            if (value == "") {
                callback(new Error("请输入旧密码"));
            } else {
                //     if (this.form.oldPwd !== "") {
                //         this.$refs.form.validateField("oldPwd");
                //     }
                callback();
            }
        };
        let validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
              let reg = /((?=.*[a-z])(?=.*\d)|(?=[a-z])(?=.*[#@!~%^&*.])|(?=.*\d)(?=.*[#@!~%^&*.]))[a-z\d#@!~%^&*.]{8,}/gi
                if (!reg.test(value)) {
                    // this.$refs.form.validateField("checkPass");
                    callback(new Error('密码长度8位以上，密码复杂度为数字、字母及特殊字符两种以上组合!'))
                }
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.form.newPwd) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        let nameRules = (rule, value, callback) => {
            if (value === "" || !isUserName.test(value)) {
                callback(new Error("非空，中文10个字符"));
            } else {
                callback();
            }
        };
        let emailRules = (rule, value, callback) => {
            if (value != "" && !isEmail.test(value)) {
                callback(new Error("请输入正确的邮箱格式"));
            } else {
                callback();
            }
        };
        return {
            login: "",
            name: "",
            phone: "",
            email: "",
            wechat: "",
            changePwd: false,
            editMsg: false,
            funList: [],
            form: {
                // login:login,
                oldPwd: "",
                newPwd: "",
                newPwdAgain: "",
                eyeShow: false,
                eyeShow1: false,
                eyeShow2: false
            },
            rules: {
                oldPwd: [
                    { required: true, validator: oldPwd, trigger: "blur" }
                ],
                newPwd: [
                    { required: true, validator: validatePass, trigger: "blur" }
                ],
                newPwdAgain: [
                    {
                        required: true,
                        validator: validatePass2,
                        trigger: "blur"
                    }
                ]
            },
            msgForm: {
                name: "",
                phone: "",
                email: "",
                wechat: ""
            },
            msgRules: {

                phone: [
                    {

                        pattern: /^1[3|5|8|7|9|6][0-9]{9}$/,

                        message: '格式不正确',

                        trigger: 'blur'

                        }
                ],
                name: [
                    { required: true, validator: nameRules, trigger: "blur" }
                ],
                email: [{ validator: emailRules, trigger: "blur" }]
            },
            formLabelWidth: "120px"
        };
    },
    created() {
        let userInfot = this._util.getStorage("ssoUserInfo");
        this.login = userInfot.account;
        this.name = userInfot.name;
        this.phone = userInfot.phone;
        this.email = userInfot.email;
        this.wechat = userInfot.wechat;
        this.accountId = userInfot.accountId;
        this.getRoleFunList();
    },
    methods: {
        gosetting(a) {
            if (a !== "/exit") {
                this.$router.push({
                    path: a
                });
            } else {
                localStorage.clear();
                window.localStorage.clear();
                // window.location = window.expertConfig.newUrl+'exit';
                let data = {
                    accountId: this.accountId
                };
                loginAPI.dologOut(data).then(res => {
                    if (res.code == 0) {
                        this.$router.push({
                            path: "/"
                        });
                    }
                });
            }
        },
        getRoleFunList() {
            let data = {
                accountId: this.accountId
            };
            loginAPI.getRoleFunList(data).then(res => {
                if (res.code == 0) {
                    this.funList = res.data.funList;
                    this._util.setStorage(
                        "ssoNav",
                        res.data.funList[0].funSonList
                    );
                }
            });
        },
        editMessage() {
            this.editMsg = true;
            this.msgForm.name = this.name;
            this.msgForm.phone = this.phone;
            this.msgForm.email = this.email;
            this.msgForm.wechat = this.wechat;
        },
        changePwdSure(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let d = {
                        password: this.form.oldPwd,
                        accountId: _util.getStorage('ssoUserInfo').accountId
                    }
                    let that = this
                    userInfo.validatePassword(d).then(res => {
                        if(res.data) {
                                              
                        userInfo
                            .updataPassword({
                                accountId: this.accountId,
                                newPassword: this.form.newPwd,
                                oldPassword: this.form.oldPwd
                            })
                            .then(res => {
                                if (res.code == "0") {
                                    that.changePwd = false;
                                    that.$confirm(
                                        "密码修改成功，请重新登录",
                                        "提示",
                                        {
                                            confirmButtonText: "确定",
                                            type: "warning",
                                            showCancelButton: false,
                                            closeOnClickModal: false,
                                            center: true,
                                            showClose: false
                                        }
                                    ).then(() => {
                                        localStorage.clear();
                                        let data = {
                                            accountId: that.accountId
                                        };
                                        loginAPI.dologOut(data).then(res => {
                                            if (res.code == 0) {
                                                that.$router.push({
                                                    path: "/"
                                                });
                                            }
                                        });
                                    });
                                } else {
                                    that.$message.error(res.msg);
                                }
                            });  
                        } else {
                            that.$message.error("原密码错误！");
                        }
                    })

                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        changeMsgSure(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    userInfo
                        .updataUserInfo({
                            name: this.msgForm.name,
                            email: this.msgForm.email,
                            phone: this.msgForm.phone,
                            wechat: this.msgForm.wechat,
                            accountId: this.accountId
                        })
                        .then(res => {
                            if (res.code == 0) {
                                this.editMsg = false;
                                let userInfot = this._util.getStorage(
                                    "ssoUserInfo"
                                );
                                userInfot.name = this.name = this.msgForm.name;
                                userInfot.phone = this.phone = this.msgForm.phone;
                                userInfot.email = this.email = this.msgForm.email;
                                userInfot.wechat = this.wechat = this.msgForm.wechat;
                                this._util.setStorage("ssoUserInfo", userInfot);
                            }
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        }
    },
    mounted() {}
};
</script>
<style lang='less'>

html,
body {
    width: 100%;
    height: 100%;
}
#app {
    width: 100%;
    height: 100%;
}
.userinfo {
    width: 100%;
    height: 100%;
    background: #f2f2f2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 560px;
    overflow: auto;
}
.header {
    width: 100%;
    height: 64px;
    background-color: #0f2847;
    box-shadow: 0 2px 15px #e5e5e5;
    z-index: 888;
    min-width: 1100px;
    position: relative;
    .logo {
        width: 600px;
        float: left;
        height: 64px;
        padding: 8px 0;
        margin-left: 3%;
        overflow: hidden;
        font-size: 0;
        .wid300 {
            max-width: 100%;
            line-height: 48px;
        }
        .logo_txt {
            display: inline-block;
            font-size: 24px;
            color: #fff;
            vertical-align: middle;
            max-height: 48px;
            overflow: hidden;
        }
    }
    .userinfo_box {
        float: right;
        // margin-right: 5%;
    }
    .sys_setup {
        display: inline-block;
        width: 23px;
        height: 23px;
        background: url(../../images/setting.png) no-repeat;
        background-size: 20px 20px;
        vertical-align: top;
        margin: -1px 0 0 10px;
        cursor: pointer;
    }
}
.userContent {
    flex: 1;
    .content {
        margin: 24px auto 30px;
        width: 94%;
        min-height: 500px;
        position: relative;
        background-color: #fff;
        margin: 20px auto 0;
        .tit {
            height: 65px;
            border-bottom: 1px solid rgb(229, 229, 229);
            span {
                border-bottom: 2px solid #38a9e1;
                color: #1f96d2;
                display: inline-block;
                height: 64px;
                line-height: 64px;
                text-align: center;
                margin-left: 30px;
                font-size: 16px;
                font-family: "黑体";
            }
        }
        .changBtn {
            padding: 20px 0;
            background: #fafafa;
            padding-left: 100px;
        }
        ul {
            margin-left: 123px;
            li {
                margin: 22px 0;
                color: #676767;
                span {
                    display: inline-block;
                    width: 80px;
                    text-align: right;
                    margin-right: 40px;
                }
            }
        }
    }
}

.el-form-item__content {
    position: relative !important;
    .eye {
        position: absolute;
        right: 10px;
        top: 15px;
        cursor: pointer;
    }
}
.footer {
    width: 100%;
    height: 44px;
    background-color: #323333;
}
.userSetBox {
    position: relative;
    z-index: 1000;
}
.userinfo_box {
    float: right;
    // margin-right: 5%;
    // margin-top: 2%;
}
.userinfo_box .user_box {
    float: left;
    border-left: 1px solid #a5aabb;
    height: 18px;
    line-height: 18px;
    margin-top: 23px;
    margin-left: 12px;
    font-size: 0;
    position: relative;
}
.userinfo_box .user_box div.user_img {
    margin: 0 12px;
    cursor: pointer;
    display: flex;
}
.userinfo_box .user_box div.user_img img {
    display: inline-block;
    width: 16px;
    height: 16px;
    vertical-align: top;
    margin-top: 1px;
    border: 0px none;
}
.userinfo_box .user_box div.user_img span.user_name {
    font-size: 14px;
    color: #fff;
    white-space: nowrap;
}
.userinfo_box .user_box .subset_nav {
    position: absolute;
    top: 26px;
    left: -8px;
    padding: 10px 0;
    margin: 5px 0;
    background-color: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    width: 96px;
    display: none;
}
.userinfo_box .user_box .el-dropdown:hover .subset_nav {
    display: block;
}
.userinfo_box .user_box .subset_nav li {
    list-style: none;
    line-height: 36px;
    padding: 0 20px;
    margin: 0;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    outline: 0;
    width: auto;
    height: auto;
}
.userinfo_box .user_box .subset_nav li:hover {
    background-color: #ecf5ff;
}
.userinfo_box .user_box .subset_nav li:hover a {
    color: #409eff;
}
.userinfo_box .user_box .subset_nav li a {
    font-size: 14px;
    font-family: "\5B8B\4F53";
    color: #606266;
}
.userinfo_box .user_box .subset_nav li a:hover {
    color: #409eff;
}
.userinfo_box .user_box .subset_nav li a.hover {
    color: #409eff;
}
.userinfo_box .user_box .subset_nav .popper__arrow,
.userinfo_box .user_box .subset_nav .popper__arrow::after {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
}
.userinfo_box .user_box .subset_nav .popper__arrow {
    border-width: 6px;
    filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
    left: 50%;
    top: -6px;
    border-top-width: 0;
    border-bottom-color: #ebeef5;
    margin-left: -6px;
}
.userinfo_box .user_box .subset_nav .popper__arrow::after {
    content: " ";
    border-width: 6px;
    border-bottom-color: #fff;
    border-top-width: 0;
    margin-left: -6px;
    top: 1px;
}
</style>
<style scoped>
.goback {
    background: #0f2847;
    cursor: pointer;
    margin-left: 40px;
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    margin-top: 10px;
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Setting/UserInfo.vue